import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Loader from '../../Components/Loader';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';

import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { ColumnHeaderCell, EditableName, EditableCell, Cell, Column, Table, RowHeaderCell, SelectionModes } from "@blueprintjs/table";
import { ContextMenuTarget, Menu, MenuItem, Divider, Icon } from "@blueprintjs/core";


const ENDPOINT = "sonderfahrt"

const styles = theme => ({

})

export const sonderfahrt_spalten = [
    "Kurs",
    "von",
    "bis",
    "km",
    "KuLz",
    "LfLz",
    "SoMin"
]

class SonderfahrtTabelle extends React.Component {

    state = {
        sonderfahrt: []
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.sonderfahrt && nextProps.sonderfahrt.data) {
            if(nextProps.sonderfahrt.data && nextProps.sonderfahrt.data !== nextState.sonderfahrt) {
                this.state.eintraege = nextProps.sonderfahrt.data
                return true
            }
        }
        return false
    }

    header_cellRenderer = (columnIndex: number) => {
            var name = ""
            var classes = {
                "text-center": true,
                "fontSizeSmall": true
            }
            switch (columnIndex) {
                case 0:
                    classes["text-center"] = false
                    break;
                case 1:
                    classes["text-center"] = false
                    break;
                case 2:
                    classes["text-center"] = false
                    break;
                default:
                    classes["text-center"] = true
            }
            return <ColumnHeaderCell
                className={classnames(classes)}
                style={{textAlign: "center"}}
                name={sonderfahrt_spalten[columnIndex]}
            />
    }

    changeEintrag = (val, col, row) => {

    }

    confirmEintrag = (val, col, row) => {
        this.props.addEntry(val, col, row)
    }

    cellRenderer = (rowIndex: number, columnIndex: number) => {
        var name = (sonderfahrt_spalten[columnIndex]).toLowerCase()
        var value = ""
        if(this.props.sonderfahrt.data[rowIndex] && this.props.sonderfahrt.data[rowIndex][name]) {
            value = this.props.sonderfahrt.data[rowIndex][name]
        }
        var align = ""
        if(columnIndex>2) {
            align = "center"
        }
        return (
            <EditableCell
                style={{textAlign: align}}
                onChange={(value) => this.changeEintrag(value, columnIndex, rowIndex)}
                onConfirm={(value) => this.confirmEintrag(value, columnIndex, rowIndex)}
                value={value}
            />
        )
    }

    render() {

        var {
            sonderfahrt, contextMenu
        } = this.props

        return (
            <Table
                    bodyContextMenuRenderer={contextMenu}
                    enableRowResizing={false}
                    enableColumnResizing={false}
                    numRows={sonderfahrt.data && sonderfahrt.data.length + 1}
                    columnWidths={[
                        100, 220, 220, 60, 60, 60, 60
                    ]}
                    enableGhostCells={true}
                    renderMode={"none"}
                    enableFocusedCell={true}
            >
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
                <Column columnHeaderCellRenderer={this.header_cellRenderer} cellRenderer={this.cellRenderer} />
            </Table>

        )
    }

}

class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT
    }

    componentDidMount() {
        this.props.doLoad()
        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "sonderfahrt")
                if(genericData.type === "SONDERFAHRT_PUT" && !genericData.isLoading) {
                    console.log("genericData.type", genericData.type)
                    //this.props.doLoad()
                }
            }
        )
    }

    contextMenu = (val) => {
        var column = val.target.cols[0]
        var row = val.target.rows[0]

        return(
            <Menu>
                <MenuItem onClick={() => this.addEntry(0, 5, row)} icon={"changes"} text={"Typ: Kurs"} />
                <MenuItem onClick={() => this.addEntry(1, 5, row)} icon={"changes"} text={"Typ: Leerfahrt"} />
                <MenuItem onClick={() => this.addEntry(2, 5, row)} icon={"changes"} text={"Typ: Tätigkeit"} />
                <MenuItem onClick={() => this.deleteRow(row)} icon="delete" text="Zeile löschen" />
            </Menu>
        )
    }

    addEntry = (val, col, row) => {
        var name = (sonderfahrt_spalten[col]).toLowerCase()
        switch (col) {
            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
        }

        if(col > 2) {
            val = parseFloat((""+val).replace(",", "."))
        }

        if(this.props.sonderfahrt.data[row] && this.props.sonderfahrt.data[row].id) {
            this.props.sonderfahrt.data[row][name] = val
            this.state.newEntry = this.props.sonderfahrt.data[row]
            this.saveData()
        } else {
            if(!this.props.sonderfahrt.data[row]) {
                this.props.sonderfahrt.data[row] = {}
            }
            this.props.sonderfahrt.data[row][name] = val
            this.state.newEntry = this.props.sonderfahrt.data[row]
            this.postData()
        }
    }

    render() {

        var { classes, sonderfahrt } = this.props
        var { newEntry, dialogOpen, newEntry } = this.state

        return (
            <div>

                <SonderfahrtTabelle
                    contextMenu={this.contextMenu}
                    sonderfahrt={sonderfahrt}
                    addEntry={this.addEntry}
                />

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    doDelete: (id) => dispatch(doDelete(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, id)),
    doPut: (id, data) => dispatch(doPut(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, data, true)),
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/"+ENDPOINT, data, true)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Sonderfahrt/index.js